/* eslint-disable camelcase */
import { toast } from 'react-toastify';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import ToastComponent from '../../components/toast';
import {
  FeeService,
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '../../services/wealthlane-award-services';

const usePostSecFee = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(FeeService.postApiAwardApiAppFeeSecFee(payload));
    },
    {
      onSuccess: async (
        response: Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label={'Success'} message={'SEC Fee Added'} />);
          queryClient.invalidateQueries('getSecFeeList');
          closeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSecFee;
